[
  {
    "id": "denny_coughlin",
    "kind": "lead",
    "assetId": "characters.named.denny_coughlin",
    "name": "Denny Coughlin",
    "age": 49,
    "role": "Boss of the Coughlin Anchor Rope family, South Docks, third generation longshore.",
    "line": "Broad freckled face gone ruddy from weather and whiskey, thinning sandy-red hair combed straight back."
  },
  {
    "id": "elaine_mercer",
    "kind": "lead",
    "assetId": "characters.named.elaine_mercer",
    "name": "Elaine Mercer",
    "age": 40,
    "role": "Investigative reporter, the Ashport Ledger-Dispatch, city desk.",
    "line": "Slim, light brown hair blunt cut to the jaw, wire-rim glasses, chapped lips."
  },
  {
    "id": "frank_dambra",
    "kind": "lead",
    "assetId": "characters.named.frank_dambra",
    "name": "Frank D'Ambra",
    "age": 58,
    "role": "The fence.",
    "line": "Stooped and heavyset, sallow, grey hair combed thin across the scalp, a jeweler's loupe pushed up on his forehead."
  },
  {
    "id": "joanie_march",
    "kind": "lead",
    "assetId": "characters.named.joanie_march",
    "name": "Joanie March",
    "age": 29,
    "role": "Runs the March Knot crew out of the Knot on Kepler Row.",
    "line": "Behind a bar."
  },
  {
    "id": "livia_sarto",
    "kind": "lead",
    "assetId": "characters.named.livia_sarto",
    "name": "Livia Sarto",
    "age": 34,
    "role": "Attorney, admitted 1979, of counsel to nobody officially.",
    "line": "Compact and wiry, olive skin, dark curly hair scraped back with crossed bobby pins, a fine pale scar on the chin."
  },
  {
    "id": "marek_zolnier",
    "kind": "lead",
    "assetId": "characters.named.marek_zolnier",
    "name": "Marek Zolnier",
    "age": 38,
    "role": "Boss of the Zolnier Harbor Chain, Dockside.",
    "line": "Tall, thick-necked, pale, close-cropped ash-blond hair, a white scar splitting one eyebrow."
  },
  {
    "id": "nora_vale",
    "kind": "lead",
    "assetId": "characters.named.nora_vale",
    "name": "Nora Vale",
    "age": 51,
    "role": "Precinct Captain, Third District, Harbor Ward.",
    "line": "Silver-blonde hair cut short and firmly set, weathered fair skin, cold blue eyes."
  },
  {
    "id": "pete_mangan",
    "kind": "lead",
    "assetId": "characters.named.pete_mangan",
    "name": "Pete Mangan",
    "age": 44,
    "role": "Dock foreman, Dockside, and the Mangan Hammer family's man on the pier.",
    "line": "Sunburned square face, salt-and-pepper moustache, deep crow's feet."
  },
  {
    "id": "ricky_albano",
    "kind": "lead",
    "assetId": "characters.named.ricky_albano",
    "name": "Ricky Albano",
    "age": 36,
    "role": "Informant.",
    "line": "Thin to the point of gaunt, sunken cheeks, patchy stubble, greasy black hair, darting brown eyes."
  },
  {
    "id": "ruth_vandergrift",
    "kind": "lead",
    "assetId": "characters.named.ruth_vandergrift",
    "name": "Ruth Vandergrift",
    "age": 46,
    "role": "The Vandergrift Bridge Span.",
    "line": "Dark hair streaked with early silver in a low chignon, sharp jaw, cool grey-green eyes."
  },
  {
    "id": "angela_petrosino",
    "kind": "crew",
    "assetId": "characters.generic.angela_petrosino",
    "name": "Angela Petrosino",
    "age": 45,
    "group": "Crew and family (10)",
    "role": "Crew bookkeeper",
    "line": "Reading glasses on a chain, and she has never once been off by a dollar."
  },
  {
    "id": "dominic_ruzzo",
    "kind": "crew",
    "assetId": "characters.generic.dominic_ruzzo",
    "name": "Dominic Ruzzo",
    "age": 27,
    "group": "Crew and family (10)",
    "role": "Crew driver",
    "line": "Too young for the moustache, and he knows every alley in three districts."
  },
  {
    "id": "sal_ferrante",
    "kind": "crew",
    "assetId": "characters.generic.sal_ferrante",
    "name": "Sal Ferrante",
    "age": 33,
    "group": "Crew and family (10)",
    "role": "Soldier",
    "line": "Blow-dried hair, borrowed suit, and he showed up the night nobody else did."
  },
  {
    "id": "tommy_halloran",
    "kind": "crew",
    "assetId": "characters.generic.tommy_halloran",
    "name": "Tommy Halloran",
    "age": 31,
    "group": "Crew and family (10)",
    "role": "Leg-breaker",
    "line": "Cauliflower ear and a genuinely gentle voice, which is the frightening part."
  },
  {
    "id": "giulia_fanucci",
    "kind": "crew",
    "assetId": "characters.generic.giulia_fanucci",
    "name": "Giulia Fanucci",
    "age": 47,
    "group": "Crew and family (10)",
    "role": "Butcher, crew associate",
    "line": "Runs Fanucci Meats, holds the Flats cold cache, and misses nothing."
  },
  {
    "id": "hector_delgado",
    "kind": "crew",
    "assetId": "characters.generic.hector_delgado",
    "name": "Hector Delgado",
    "age": 29,
    "group": "Crew and family (10)",
    "role": "Street crew",
    "line": "Crescent scar on the jaw from a job he still will not describe."
  },
  {
    "id": "mickey_doyle",
    "kind": "crew",
    "assetId": "characters.generic.mickey_doyle",
    "name": "Mickey Doyle",
    "age": 25,
    "group": "Crew and family (10)",
    "role": "Dockhand, paid lookout",
    "line": "Twenty-five and already knows the exact price of everything he does."
  },
  {
    "id": "curtis_ames",
    "kind": "crew",
    "assetId": "characters.generic.curtis_ames",
    "name": "Curtis Ames",
    "age": 38,
    "group": "Crew and family (10)",
    "role": "Numbers runner",
    "line": "A salesman's smile and a route he has walked six days a week since 1979."
  },
  {
    "id": "omar_batiste",
    "kind": "crew",
    "assetId": "characters.generic.omar_batiste",
    "name": "Omar Batiste",
    "age": 43,
    "group": "Crew and family (10)",
    "role": "Club doorman, quiet muscle",
    "line": "Diamond stud, folded arms, and he remembers every face he ever turned away."
  },
  {
    "id": "dez_mulcahy",
    "kind": "crew",
    "assetId": "characters.generic.dez_mulcahy",
    "name": "Dez Mulcahy",
    "age": 35,
    "group": "Crew and family (10)",
    "role": "Arsonist for hire",
    "line": "Eyebrows singed short. Talks about fire the way other people talk about weather."
  },
  {
    "id": "milagros_rosario",
    "kind": "crew",
    "assetId": "characters.generic.milagros_rosario",
    "name": "Milagros Rosario",
    "age": 35,
    "group": "Market sellers and fences (14)",
    "role": "Small contraband",
    "line": "Bodega owner who will hold anything for a week and ask nothing."
  },
  {
    "id": "stefan_wiszniewski",
    "kind": "crew",
    "assetId": "characters.generic.stefan_wiszniewski",
    "name": "Stefan Wiszniewski",
    "age": 61,
    "group": "Market sellers and fences (14)",
    "role": "Weapons, accessories",
    "line": "Surplus shop, flat brush cut, and a receipt book he actually fills in."
  },
  {
    "id": "bobby_sciarra",
    "kind": "crew",
    "assetId": "characters.generic.bobby_sciarra",
    "name": "Bobby Sciarra",
    "age": 28,
    "group": "Market sellers and fences (14)",
    "role": "Vehicles, parts",
    "line": "Can strip a coupe in forty minutes and will tell you so twice."
  },
  {
    "id": "vito_carnera",
    "kind": "crew",
    "assetId": "characters.generic.vito_carnera",
    "name": "Vito Carnera",
    "age": 65,
    "group": "Market sellers and fences (14)",
    "role": "Documents, passports",
    "line": "Retired button man who found out he had good hands and better patience."
  },
  {
    "id": "halyna_kovalenko",
    "kind": "crew",
    "assetId": "characters.generic.halyna_kovalenko",
    "name": "Halyna Kovalenko",
    "age": 47,
    "group": "Market sellers and fences (14)",
    "role": "Medical supplies",
    "line": "Sells under the counter and counts out loud so that you cannot lie."
  },
  {
    "id": "oksana_petrenko",
    "kind": "crew",
    "assetId": "characters.generic.oksana_petrenko",
    "name": "Oksana Petrenko",
    "age": 44,
    "group": "Market sellers and fences (14)",
    "role": "Contraband brokerage",
    "line": "Sharp bob, and prices that never move once quoted."
  },
  {
    "id": "theo_dranias",
    "kind": "crew",
    "assetId": "characters.generic.theo_dranias",
    "name": "Theo Dranias",
    "age": 59,
    "group": "Market sellers and fences (14)",
    "role": "Cargo, manifests",
    "line": "Chief mate who moves things off the books and takes cash only."
  },
  {
    "id": "harold_speck",
    "kind": "crew",
    "assetId": "characters.generic.harold_speck",
    "name": "Harold Speck",
    "age": 62,
    "group": "Market sellers and fences (14)",
    "role": "Insurance fraud",
    "line": "Bifocals, and he has never written an honest claim on a Tuesday."
  },
  {
    "id": "marcus_teale",
    "kind": "crew",
    "assetId": "characters.generic.marcus_teale",
    "name": "Marcus Teale",
    "age": 39,
    "group": "Market sellers and fences (14)",
    "role": "Bookmaking lines",
    "line": "Half-glasses low on the nose and the best mental arithmetic on the Row."
  },
  {
    "id": "wanda_pryce",
    "kind": "crew",
    "assetId": "characters.generic.wanda_pryce",
    "name": "Wanda Pryce",
    "age": 52,
    "group": "Market sellers and fences (14)",
    "role": "Policy bank",
    "line": "Largest numbers bank on the north side, and she pays out same day, always."
  },
  {
    "id": "sophia_petrakis",
    "kind": "crew",
    "assetId": "characters.generic.sophia_petrakis",
    "name": "Sophia Petrakis",
    "age": 45,
    "group": "Market sellers and fences (14)",
    "role": "Transport, drivers",
    "line": "Pencil through her hair, and she can put a car anywhere in nine minutes."
  },
  {
    "id": "tessa_nowak",
    "kind": "crew",
    "assetId": "characters.generic.tessa_nowak",
    "name": "Tessa Nowak",
    "age": 30,
    "group": "Market sellers and fences (14)",
    "role": "Warehouse access",
    "line": "Signs what needs signing and has never once asked why."
  },
  {
    "id": "andriy_melnyk",
    "kind": "crew",
    "assetId": "characters.generic.andriy_melnyk",
    "name": "Andriy Melnyk",
    "age": 36,
    "group": "Market sellers and fences (14)",
    "role": "Laundering, tier 1",
    "line": "Washing cash through a flour-dusted count room he inherited by accident."
  },
  {
    "id": "bridget_kilbane",
    "kind": "crew",
    "assetId": "characters.generic.bridget_kilbane",
    "name": "Bridget Kilbane",
    "age": 40,
    "group": "Market sellers and fences (14)",
    "role": "Laundering, tier 1",
    "line": "Runs Kilbane Wash and the garment route, and is better at this than her partners."
  },
  {
    "id": "gus_manolis",
    "kind": "crew",
    "assetId": "characters.generic.gus_manolis",
    "name": "Lt. Gus Manolis",
    "age": 58,
    "group": "Police and federal (7)",
    "role": "OC Task Force lieutenant",
    "line": "Bull neck, comb-over, and a nineteen-year grudge against a city that includes his brother."
  },
  {
    "id": "adele_beckwith",
    "kind": "crew",
    "assetId": "characters.generic.adele_beckwith",
    "name": "Det. Adele Beckwith",
    "age": 44,
    "group": "Police and federal (7)",
    "role": "Homicide",
    "line": "Small gold studs, a scar on the bridge of the nose, and she closes cases."
  },
  {
    "id": "colm_rafferty",
    "kind": "crew",
    "assetId": "characters.generic.colm_rafferty",
    "name": "Sgt. Colm Rafferty",
    "age": 50,
    "group": "Police and federal (7)",
    "role": "Desk sergeant, Little Sicily",
    "line": "Knows everybody's mother and takes the envelope like he is doing you a favour."
  },
  {
    "id": "dana_kubiak",
    "kind": "crew",
    "assetId": "characters.generic.dana_kubiak",
    "name": "Ofc. Dana Kubiak",
    "age": 26,
    "group": "Police and federal (7)",
    "role": "Rookie patrol",
    "line": "Braided tight, and she has not yet learned which calls not to answer."
  },
  {
    "id": "priscilla_hoyt",
    "kind": "crew",
    "assetId": "characters.generic.priscilla_hoyt",
    "name": "SA Priscilla Hoyt",
    "age": 39,
    "group": "Police and federal (7)",
    "role": "Federal agent",
    "line": "Stiffly formal, and she is the one building the RICO case."
  },
  {
    "id": "ray_ocasio",
    "kind": "crew",
    "assetId": "characters.generic.ray_ocasio",
    "name": "SA Ray Ocasio",
    "age": 34,
    "group": "Police and federal (7)",
    "role": "Federal, undercover",
    "line": "Hair grown out past regulation, eleven months into Kepler Row."
  },
  {
    "id": "yvette_braddock",
    "kind": "crew",
    "assetId": "characters.generic.yvette_braddock",
    "name": "DUSM Yvette Braddock",
    "age": 42,
    "group": "Police and federal (7)",
    "role": "Deputy marshal",
    "line": "Short twists, a burn scar on one hand, and she serves the bench warrant."
  },
  {
    "id": "amos_fry",
    "kind": "crew",
    "assetId": "characters.generic.amos_fry",
    "name": "Deacon Amos Fry",
    "age": 57,
    "group": "Civic and job NPCs (9)",
    "role": "Storefront church deacon",
    "line": "Will take your money for the roof and for nothing else, ever."
  },
  {
    "id": "coleen_brady",
    "kind": "crew",
    "assetId": "characters.generic.coleen_brady",
    "name": "Coleen Brady",
    "age": 34,
    "group": "Civic and job NPCs (9)",
    "role": "Hospital night nurse",
    "line": "Exhausted, freckled, and she does not write down what she does not have to."
  },
  {
    "id": "irene_kozlow",
    "kind": "crew",
    "assetId": "characters.generic.irene_kozlow",
    "name": "Irene Kozlow",
    "age": 51,
    "group": "Civic and job NPCs (9)",
    "role": "City hall records clerk",
    "line": "Cameo brooch, and a rate card for every file in the building."
  },
  {
    "id": "rosalie_grieco",
    "kind": "crew",
    "assetId": "characters.generic.rosalie_grieco",
    "name": "Rosalie Grieco",
    "age": 63,
    "group": "Civic and job NPCs (9)",
    "role": "Tenement landlady",
    "line": "Thick lenses, tight white curls, and she knows who came home and when."
  },
  {
    "id": "yiannis_stamatis",
    "kind": "crew",
    "assetId": "characters.generic.yiannis_stamatis",
    "name": "Yiannis Stamatis",
    "age": 56,
    "group": "Civic and job NPCs (9)",
    "role": "Diner owner",
    "line": "Feeds cops and crews the same eggs and charges both the same."
  },
  {
    "id": "wendell_pruitt",
    "kind": "crew",
    "assetId": "characters.generic.wendell_pruitt",
    "name": "Wendell Pruitt",
    "age": 65,
    "group": "Civic and job NPCs (9)",
    "role": "Ward heeler, vote fixer",
    "line": "Gold-rimmed glasses, and he can find you four hundred votes by Thursday."
  },
  {
    "id": "nadia_zabek",
    "kind": "crew",
    "assetId": "characters.generic.nadia_zabek",
    "name": "Nadia Zabek",
    "age": 33,
    "group": "Civic and job NPCs (9)",
    "role": "Surveillance photographer",
    "line": "Chewed nails, and she sells the same roll of film twice when she can."
  },
  {
    "id": "elmore_whitcomb",
    "kind": "crew",
    "assetId": "characters.generic.elmore_whitcomb",
    "name": "Elmore Whitcomb",
    "age": 48,
    "group": "Civic and job NPCs (9)",
    "role": "Tugboat engineer",
    "line": "Forearms like cable, and he decides what enters the channel at night."
  },
  {
    "id": "loretta_voss",
    "kind": "crew",
    "assetId": "characters.generic.loretta_voss",
    "name": "Loretta Voss",
    "age": 55,
    "group": "Civic and job NPCs (9)",
    "role": "Bail bondswoman",
    "line": "Lacquered blonde helmet, blue eyeshadow, and completely unbothered by any of it."
  },
  {
    "id": "eamon_traynor",
    "kind": "crew",
    "assetId": "characters.generic.eamon_traynor",
    "name": "Eamon Traynor",
    "age": 60,
    "group": "Rivals (5)",
    "role": "Rival union boss, Ironbound",
    "line": "Combed hard, and he has beaten better men than you with a vote count."
  },
  {
    "id": "kaz_drozd",
    "kind": "crew",
    "assetId": "characters.generic.kaz_drozd",
    "name": "Kaz Drozd",
    "age": 41,
    "group": "Rivals (5)",
    "role": "Rival enforcer, Zolnier crew",
    "line": "Shaven head, boxer's nose, and he puts his coffee down before he answers."
  },
  {
    "id": "rafa_quinones",
    "kind": "crew",
    "assetId": "characters.generic.rafa_quinones",
    "name": "Rafa Quinones",
    "age": 32,
    "group": "Rivals (5)",
    "role": "Street organisation, Cinder Park",
    "line": "Scar splitting one brow, and no interest at all in becoming a Family."
  },
  {
    "id": "simone_cutter",
    "kind": "crew",
    "assetId": "characters.generic.simone_cutter",
    "name": "Simone Cutter",
    "age": 37,
    "group": "Rivals (5)",
    "role": "Rival crew boss, Harbor Ward",
    "line": "Door-knocker earrings, and the fastest read in any room she enters."
  },
  {
    "id": "vince_bonnaro",
    "kind": "crew",
    "assetId": "characters.generic.vince_bonnaro",
    "name": "Vince Bonnaro",
    "age": 54,
    "group": "Rivals (5)",
    "role": "Rival capo, Parisi crew",
    "line": "Cadaverously thin, and he has never personally hurt anybody."
  },
  {
    "id": "micky_sarno",
    "kind": "target",
    "assetId": "pvp.targets.micky_sarno",
    "name": "Micky Sarno",
    "age": 61,
    "tier": 6,
    "tierName": "Citywide",
    "line": "Took a Commission envelope into the federal building and came out without it."
  },
  {
    "id": "rosalind_ekwueme",
    "kind": "target",
    "assetId": "pvp.targets.rosalind_ekwueme",
    "name": "Rosalind Ekwueme",
    "age": 45,
    "tier": 6,
    "tierName": "Citywide",
    "line": "Holds the only complete copy of the Harbor Ward ledger and will not sell it."
  },
  {
    "id": "emmett_ballentine",
    "kind": "target",
    "assetId": "pvp.targets.emmett_ballentine",
    "name": "Emmett Ballentine",
    "age": 52,
    "tier": 5,
    "tierName": "Blood Price",
    "line": "Dock contractor who bid against three families at once and won."
  },
  {
    "id": "yelena_drachuk",
    "kind": "target",
    "assetId": "pvp.targets.yelena_drachuk",
    "name": "Yelena Drachuk",
    "age": 31,
    "tier": 5,
    "tierName": "Blood Price",
    "line": "Moved a shipment that was already sold. Twice, to different buyers."
  },
  {
    "id": "hector_villalta",
    "kind": "target",
    "assetId": "pvp.targets.hector_villalta",
    "name": "Hector Villalta",
    "age": 49,
    "tier": 5,
    "tierName": "Blood Price",
    "line": "Named two men in a deposition and is still walking around Verity Hill."
  },
  {
    "id": "grete_lindqvist",
    "kind": "target",
    "assetId": "pvp.targets.grete_lindqvist",
    "name": "Grete Lindqvist",
    "age": 50,
    "tier": 4,
    "tierName": "High Value",
    "line": "Auditor who found the Vandergrift discrepancy and told the wrong person."
  },
  {
    "id": "salim_nadir",
    "kind": "target",
    "assetId": "pvp.targets.salim_nadir",
    "name": "Salim Nadir",
    "age": 39,
    "tier": 4,
    "tierName": "High Value",
    "line": "Broke a Sitdown two Eras ago and has been paying for it in instalments since."
  },
  {
    "id": "camille_ozaki",
    "kind": "target",
    "assetId": "pvp.targets.camille_ozaki",
    "name": "Camille Ozaki",
    "age": 38,
    "tier": 4,
    "tierName": "High Value",
    "line": "Sells the same surveillance to both sides and has never been caught at it."
  },
  {
    "id": "aurelio_bask",
    "kind": "target",
    "assetId": "pvp.targets.aurelio_bask",
    "name": "Aurelio Bask",
    "age": 47,
    "tier": 4,
    "tierName": "High Value",
    "line": "Owes the Parisi crew ninety-one thousand and left for Florida on Tuesday."
  },
  {
    "id": "suki_alvarado_chen",
    "kind": "target",
    "assetId": "pvp.targets.suki_alvarado_chen",
    "name": "Suki Alvarado-Chen",
    "age": 43,
    "tier": 3,
    "tierName": "Hunted",
    "line": "Jade ring, heavy forearms, and the only competing fence on Kepler Row."
  },
  {
    "id": "ines_barquero",
    "kind": "target",
    "assetId": "pvp.targets.ines_barquero",
    "name": "Ines Barquero",
    "age": 41,
    "tier": 3,
    "tierName": "Hunted",
    "line": "Cigarette going, and she knows which harbor pilot takes money."
  },
  {
    "id": "tomasz_wiercinski",
    "kind": "target",
    "assetId": "pvp.targets.tomasz_wiercinski",
    "name": "Tomasz Wiercinski",
    "age": 52,
    "tier": 3,
    "tierName": "Hunted",
    "line": "Shop steward who called a wildcat that cost somebody a shipment."
  },
  {
    "id": "ferris_odum",
    "kind": "target",
    "assetId": "pvp.targets.ferris_odum",
    "name": "Ferris Odum",
    "age": 44,
    "tier": 3,
    "tierName": "Hunted",
    "line": "Gold-capped tooth, and a policy bank that shorted the wrong customer."
  },
  {
    "id": "kwan_ho_suh",
    "kind": "target",
    "assetId": "pvp.targets.kwan_ho_suh",
    "name": "Kwan Ho Suh",
    "age": 36,
    "tier": 3,
    "tierName": "Hunted",
    "line": "Burn scar down one side, from a fire he was supposed to be inside."
  },
  {
    "id": "deshawn_pyle",
    "kind": "target",
    "assetId": "pvp.targets.deshawn_pyle",
    "name": "Deshawn Pyle",
    "age": 33,
    "tier": 2,
    "tierName": "Marked",
    "line": "Union pin on the lapel and a vote he sold to two different people."
  },
  {
    "id": "colleen_braddick",
    "kind": "target",
    "assetId": "pvp.targets.colleen_braddick",
    "name": "Colleen Braddick",
    "age": 56,
    "tier": 2,
    "tierName": "Marked",
    "line": "Kept a second set of books for herself, which is not the arrangement."
  },
  {
    "id": "wanda_krol",
    "kind": "target",
    "assetId": "pvp.targets.wanda_krol",
    "name": "Wanda Krol",
    "age": 62,
    "tier": 2,
    "tierName": "Marked",
    "line": "Small, stooped, hard-eyed, and she gave a licence plate to the Third."
  },
  {
    "id": "priya_ganeshan",
    "kind": "target",
    "assetId": "pvp.targets.priya_ganeshan",
    "name": "Priya Ganeshan",
    "age": 35,
    "tier": 2,
    "tierName": "Marked",
    "line": "Glasses taped at one arm. Wrote down a conversation she was not part of."
  },
  {
    "id": "nadine_foy",
    "kind": "target",
    "assetId": "pvp.targets.nadine_foy",
    "name": "Nadine Foy",
    "age": 29,
    "tier": 2,
    "tierName": "Marked",
    "line": "Taped nose, and a debt four weeks past the last warning."
  },
  {
    "id": "maribel_tanaka_ruiz",
    "kind": "target",
    "assetId": "pvp.targets.maribel_tanaka_ruiz",
    "name": "Maribel Tanaka-Ruiz",
    "age": 27,
    "tier": 1,
    "tierName": "Street Mark",
    "line": "Bleached streak, quick hands, and she lifted the wrong man's watch."
  },
  {
    "id": "boyd_halleran",
    "kind": "target",
    "assetId": "pvp.targets.boyd_halleran",
    "name": "Boyd Halleran",
    "age": 26,
    "tier": 1,
    "tierName": "Street Mark",
    "line": "Six-three, underweight, and he talks in bars about work he did not do."
  },
  {
    "id": "dessie_kroll",
    "kind": "target",
    "assetId": "pvp.targets.dessie_kroll",
    "name": "Dessie Kroll",
    "age": 34,
    "tier": 1,
    "tierName": "Street Mark",
    "line": "Chipped front tooth and a habit of borrowing cars that belong to crews."
  },
  {
    "id": "ozzie_trelane",
    "kind": "target",
    "assetId": "pvp.targets.ozzie_trelane",
    "name": "Ozzie Trelane",
    "age": 23,
    "tier": 1,
    "tierName": "Street Mark",
    "line": "Scabbed knuckle, plastic bag, and he has not paid anybody back yet."
  },
  {
    "id": "artie_vosberg",
    "kind": "target",
    "assetId": "pvp.targets.artie_vosberg",
    "name": "Artie Vosberg",
    "age": 58,
    "tier": 1,
    "tierName": "Street Mark",
    "line": "Bald, thick-necked, and long past the point where anyone is afraid of him."
  }
]
